import { Button, ButtonProps, Spinner } from 'react-bootstrap';

interface SubmitButtonProps extends ButtonProps {
  loading: boolean;
  buttonText: string;
}

const SubmitButton = ({ loading, disabled, buttonText, ...props }: SubmitButtonProps) => {
  return (
    <Button size="lg" className="w-100 mb-3" disabled={loading || disabled} {...props}>
      {loading ? <Spinner as="span" animation="border" size="sm" role="status" /> : `${buttonText}`}
    </Button>
  );
};

export default SubmitButton;
